import FormuleComposant from '../formule.composant.model';
import * as _ from 'lodash';

export default class FormuleProduitComplementaireController {
	/* @ngInject */
	constructor(
		$scope,
		_,
		$state,
		$stateParams,
		FormulesCommunicationService,
		FormuleService,
		ModalService,
		notification,
		SitesService,
		$filter,
		$uibModal,
		$translate,
		moment,
		MassiaApplicationService
	) {
		this.$scope = $scope;
		this._ = _;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.params = $stateParams;
		this.FormulesCommunicationService = FormulesCommunicationService;
		this.FormuleService = FormuleService;
		this.ModalService = ModalService;
		this.notification = notification;
		this.SitesService = SitesService;
		this.$filter = $filter;
		this.$uibModal = $uibModal;
		this.$translate = $translate;
		this.moment = moment;
		this.MassiaService = MassiaApplicationService;
	}

	async $onInit() {
		this.inEdit = false;
		this.IdProduit = this.params.produitId;
		this.IdProducteur = this.params.producteurId;
		await this.getElementsSelectionnables();
	}

	$onDestroy() {
		/*  this.unregisterReinit(); */
	}

	async getElementsSelectionnables() {
		try {
			this.allProduits = await this.FormuleService.getAllProduits(this.formules.producteurId, this.formules.produitId, 'gestion');
			let idProducteur = this.params.producteurId;
			let idProduit = this.IdProduit;
			let indexProduit = this.allProduits.findIndex((p) => p.produitId == idProduit && p.producteurId == idProducteur);
			this.allProduits.splice(indexProduit, 1);
			this.produits = await this.prepareListeElementsLies(this.allProduits);
			this.liste = this.produits;
		} catch (err) {
			if (err.data) this.notification.error(err.data);
			else throw err;
		}
	}
	async prepareListeElementsLies(elementsATraiter) {
		var elementsSelectionnablesOrdonnes = this.$filter('orderBy')(elementsATraiter, 'producteurLibelle');
		var tmp = null;
		var temp = [];
		for (var index = 0; index < elementsSelectionnablesOrdonnes.length; index++) {
			var currentValue = elementsSelectionnablesOrdonnes[index];
			var toReturn = [];

			if (Object.prototype.hasOwnProperty.call(currentValue, 'modeDeclenchement')) {
				currentValue.idComposant = currentValue.id;
				toReturn.push(currentValue);
			} else {
				if (tmp == null) {
					tmp = currentValue.producteurId;
					toReturn.push({
						libelle: '<span="font-weight:bold">' + currentValue.producteurLibelle + '</span>',
						msGroup: true
					});
				} else {
					if (tmp != currentValue.producteurId) {
						toReturn.push({ msGroup: false });
						tmp = currentValue.producteurId;
						toReturn.push({
							libelle: '<span="font-weight:bold">' + currentValue.producteurLibelle + '</span>',
							msGroup: true
						});
					}
				}

				currentValue.libelle = currentValue.produitCode + ' - ' + currentValue.produitLibelle;
				currentValue.valeur = false;
				currentValue.idComposant = currentValue.produitId;
				currentValue.code = currentValue.produitCode;
				currentValue.IdProducteur = currentValue.producteurId;
				currentValue.libelleFamille = currentValue.familleLibelle;

				if (!(currentValue.produitId == this.formule.idProduit && currentValue.producteurId == this.formule.idProducteur))
					toReturn.push(currentValue);

				if (index == elementsSelectionnablesOrdonnes.length - 1) {
					toReturn.push({ msGroup: false });
				}
			}
			temp.push(toReturn);
		}
		var sorties = _.flatten(temp);
		return new Promise((resolve) => resolve(sorties));
	}

	async deleteSingleComposant(obj) {
		const index = this.formule.composantComplementaires.indexOf(obj);
		if (index >= 0) {
			this.formule.composantComplementaires.splice(index, 1);
		}
	}

	async addComposant() {
		let composant = new FormuleComposant({
			idComposant: this.composant[0].idComposant,
			idProducteur: this.composant[0].producteurId || null,
			libelleProducteur: this.composant[0].producteurLibelle,
			code: this.composant[0].code,
			codeFamille: this.composant[0].codeFamille,
			libelle: this.composant[0].libelle.substring(this.composant[0].code.length + 3),
			quantite: this.quantite || 0,
			libelleFamille: this.composant[0].libelleFamille,
			idElement: this.composant[0].idComposant,
			unitePesee: this.composant[0].unitePesee
		});
		this.formule.composantComplementaires.push(composant);
	}

	async valideComposant(elm) {
		elm.quantite = this.tmpQuantite;
		elm.editCompo = false;
		this.inEdit = false;
		this.tmpQuantite = 0;
	}

	annuleComposant(elm) {
		elm.editCompo = false;
		this.inEdit = false;
		this.tmpQuantite = 0;
	}

	editComposant(elm) {
		this.inEdit = true;
		this.tmpQuantite = Number(elm.quantite) || 0;
		elm.editCompo = true;
	}
}
